module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DD79_1SE_HXR.56ce4f4d.jpg";